import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
// eslint-disable-next-line no-restricted-imports
import { lighten, makeStyles } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import PlusIcon from '@material-ui/icons/Add'
import { useSelector } from "react-redux";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Paper,
  Tooltip,
  CircularProgress,
} from '@material-ui/core'

const headRows = [
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: 'Ad',
  },

  {
    id: 'tools',
    numeric: false,
    disablePadding: true,
    label: 'Əməliyyatlar',
  },
]

function EnhancedTableHead(props) {
  const { order, orderBy, } = props

  return (
    <TableHead>
      <TableRow>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? 'right' : 'left'}
            sortDirection={orderBy === row.id ? false : false}
          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order ? 'asc' : 'desc'}
            // onClick={() => {
            //   return row.id !== 'tools' ? onRequestSort(row.id) : null
            // }}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,

}

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },

  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  dense: {
    margin: theme.spacing(2),
  },
}))

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles()
  const { numSelected, setShowCreate, permissionList } = props

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.actions}>
        {permissionList.some(element => element === "create_role") &&

          <Tooltip title="Əlavə et" placement="top">
            <button
              className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle flex-shrink-0"
              onClick={() => setShowCreate(true)}
            >
              <PlusIcon />
            </button>
          </Tooltip>}
      </div>
    </Toolbar>
  )
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  progresRoot: {
    width: '100%',
    padding: '32px 16px',
  },
  progress: {
    margin: 'auto',
    display: 'block',
    color: '#072C8C',
  },
}))

export default function EnhancedTable({
  roles,
  isLoading,
  setChooseRoleId,
  setShowLog,
  setShowCreate,
  setShowRemove,
  setShowRemoveRoles,
  setShowEdit,
  deleteRolesIds,
  setDeleteRolesIds,
  isError,
}) {
  const classes = useStyles()
  const permissionList = useSelector(state => state.auth.permissionList)

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = roles.map((n) => n.id)
      setDeleteRolesIds(newSelecteds)
      return
    }
    setDeleteRolesIds([])
  }

  const isSelected = (id) => deleteRolesIds.indexOf(id) !== -1

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {isLoading && (
          <div className={classes.progresRoot}>
            <CircularProgress className={classes.progress} />
          </div>
        )}
        <EnhancedTableToolbar
          numSelected={deleteRolesIds.length}
          setShowCreate={setShowCreate}
          setShowRemoveRoles={setShowRemoveRoles}
          permissionList={permissionList}
        />

        <div className={classes.tableWrapper}>
          {roles.length ? (
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                numSelected={deleteRolesIds.length}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {roles.map((row, index) => {
                  const isItemSelected = isSelected(row.id)
                  const labelId = `enhanced-table-checkbox-${index}`
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      <TableCell component="th" id={labelId} scope="row">
                        {row.name}
                      </TableCell>

                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      // padding="none"
                      >
                        {permissionList.some(element => element === "view_role_permission") &&

                          <Tooltip title="İcazələr" placement="top">
                            <button
                              aria-label="permission"
                              className="btn btn-sm btn-icon btn-bg-light  btn-text-warning btn-hover-warning  mr-2"
                              onClick={() => {
                                setChooseRoleId(row.id);
                                setShowLog(true);
                              }}
                            >
                              <i className="fa fa-unlock-alt text-warning"></i>
                            </button>
                          </Tooltip>}
                        {permissionList.some(element => element === "edit_role") &&

                          <Tooltip title="Düzəliş et" placement="top">
                            <button
                              aria-label="edit"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-dark btn-hover-dark mr-2"
                              onClick={() => {
                                setChooseRoleId(row.id)
                                setShowEdit(true)
                              }}
                            >
                              <EditIcon />
                            </button>
                          </Tooltip>
                        }
                        {permissionList.some(element => element === "delete_role") &&

                          <Tooltip title="Sil" placement="top">
                            <button
                              aria-label="Delete"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger  mr-2"
                              onClick={() => {
                                setChooseRoleId(row.id)
                                setShowRemove(true)
                              }}
                            >
                              <DeleteIcon />
                            </button>
                          </Tooltip>}
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          ) : !roles.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}
        </div>
      </Paper>
    </div>
  )
}
